<template>
	<Layout>
		<div class="not-found">
			<h1>404</h1>
			<h3>Siden finnes ikke</h3>
			<ButtonComponent class="mt-1" label="Til forsiden" tag="router-link" :to="{ name: 'Home' }" />
		</div>
	</Layout>
</template>

<script>
import Layout from '@/layouts/Default'
export default {
	metaInfo: {
		title: 'Siden finnes ikke',
	},
	components: {
		Layout,
	},
}
</script>

<style lang="scss">
.not-found {
	min-height: 100vh;
	padding: 10rem 0;
	text-align: center;
	color: white;
}
</style>
